var map = {
	"./NittiGrotesk-Black.eot": 61,
	"./NittiGrotesk-Black.woff": 62,
	"./NittiGrotesk-Black.woff2": 63,
	"./NittiGrotesk-Light.eot": 64,
	"./NittiGrotesk-Light.woff": 65,
	"./NittiGrotesk-Light.woff2": 66,
	"./NittiGrotesk-Medium.eot": 67,
	"./NittiGrotesk-Medium.woff": 68,
	"./NittiGrotesk-Medium.woff2": 69,
	"./NittiGrotesk-Regular.eot": 70,
	"./NittiGrotesk-Regular.woff": 71,
	"./NittiGrotesk-Regular.woff2": 72
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;